import gql from "graphql-tag";

export const GET_ASSETS = gql`
query Query($size: Int, $offset: Int, $filter:AssetFilter) {
    getAssets(size: $size, offset: $offset, filter:$filter)  {
      data {
        idx
        title
        subtitle
        serialNo
        img
        category
        price {
          type
          amount
          currency
          sale {
            salePrice
            saleEndDate
          }
          symbol
        }
      }
      currentPage
      pageSize
      totalCount
      totalPages
    }
  }
`